export enum TipoEmpresa {
  Matriz = 1,
  Filial = 2,
}
